<template>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-h6">
          <v-icon
            color="success"
            v-if="!currentUser.loggedIn"
          >
            mdi-incognito
          </v-icon>
          <v-icon
            color="success"
            v-else
          >
            mdi-account-circle-outline
          </v-icon>
          {{ user.display_name || 'Anonymous' }}
        </v-list-item-title>
        <v-list-item-subtitle>
          Universes: {{ user.organizations.length }} | Galaxies: {{ user.projects.length }}
          <span v-if="currentGalaxyName">(Current: {{ currentGalaxyName }})</span>
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="user.is_pro || user.is_pro_team">
          Subscription:
          <v-chip
            small
            :color="getSubscriptionStatusColor(user.subscription_status)"
            text-color="white"
            class="ml-1"
          >
            {{ getSubscriptionStatusText(user.subscription_status) }}
          </v-chip>
          <span v-if="user.subscription_status === 'canceled' && user.subscription_end_date">
            - Access until {{ formatDate(user.subscription_end_date) }}
          </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="user.is_pro_team && user.role">
          Role: {{ user.role }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </template>

  <script>
  export default {
    name: 'UserInfoSection',

    props: {
      user: {
        type: Object,
        required: true,
      },
      currentUser: {
        type: Object,
        required: true,
      },
      currentGalaxyName: {
        type: String,
        default: '',
      },
    },

    methods: {
      getSubscriptionStatusColor(status) {
        switch(status) {
          case 'active':
          case 'team_pro':
            return 'success';
          case 'canceled':
            return 'error';
          default:
            return 'grey';
        }
      },

      getSubscriptionStatusText(status) {
        switch(status) {
          case 'active':
            return 'Active';
          case 'team_pro':
            return 'Team Pro';
          case 'canceled':
            return 'Canceled';
          default:
            return status;
        }
      },

      formatDate(dateString) {
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      },
    },
  };
  </script>
